import React, { FC, useState, useMemo, useCallback } from 'react';
import dropDownOverlayStyles from 'src/shared/DropDownWithSearch/index.module.scss';
import styles from './index.module.scss';
import { Skeleton } from 'src/common';
import { useTranslation } from 'react-i18next';
import BidPickerItem from '../BidPickerItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IBidIdentifier, ILinkedBidIdentifier } from 'src/models/bids/Bids/types';
import { useLinkedBids } from 'src/models/bids/BidsSelector/hooks';
import { faQuestion } from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';
import { OnVisibilityTrigger, useFetchMore } from 'src/common/infinityScroll';
import { useBoolean } from 'react-use';
// import LoadMoreButton from 'src/shared/LoadMoreButton';

interface IProps {
  linkedBids: ILinkedBidIdentifier[];
  origins: string[];
  bids: IBidIdentifier[];
  eventSource: string;
  setIsUpdating: (val: boolean) => void;
  onCloseDropDown: () => void;
  onChange?: () => void;
}

const BidPickerList: FC<IProps> = props => {
  const { onCloseDropDown, linkedBids, origins, bids, setIsUpdating, onChange, eventSource } = props;
  const [container, setContainer] = useState<HTMLDivElement | null>(null);

  const { t } = useTranslation();
  const { data, loading, fetchMore } = useLinkedBids();
  const items = data?.bids || [];
  const [fetchMoreLoading, setFetchMoreLoading] = useBoolean(false);

  const total = useMemo(() => data?.total || 0, [data]);
  const isMore = useMemo(() => {
    return data && data.bids.length < total;
  }, [data, total]);

  const loadMore = useCallback(
    (variables: { offset: number }) => {
      setFetchMoreLoading(true);
      return fetchMore({
        variables
      }).finally(() => setFetchMoreLoading(false));
    },
    [fetchMore, setFetchMoreLoading]
  );

  const onLoadMore = useFetchMore({ offset: (data && data.bids.length) || 0 }, loadMore);

  return (
    <>
      <div className={classNames(dropDownOverlayStyles.container, styles.container)} ref={setContainer}>
        {loading ? (
          <Skeleton loading active className={styles.skeleton} />
        ) : !!items.length ? (
          items.map(item => (
            <BidPickerItem
              linkedBids={linkedBids}
              origins={origins}
              bids={bids}
              key={`BidPickerItem_${item.id}`}
              item={item}
              onCloseDropDown={onCloseDropDown}
              onFinish={onChange}
              setIsUpdating={setIsUpdating}
              eventSource={eventSource}
            />
          ))
        ) : (
          <div className={dropDownOverlayStyles.searchEmpty}>
            <span className={dropDownOverlayStyles.searchEmptyPic}>
              <FontAwesomeIcon icon={faQuestion} className={dropDownOverlayStyles.searchEmptyIcon} />
            </span>
            <span className={dropDownOverlayStyles.searchEmptyLabel}>{t('Common.noMatchesFound')}</span>
          </div>
        )}
        {isMore && (
          <OnVisibilityTrigger
            isLoading={fetchMoreLoading}
            onVisible={onLoadMore}
            container={container}
            style={{ display: 'block' }}
          >
            <Skeleton active loading className={styles.skeleton} paragraph />
          </OnVisibilityTrigger>
        )}
      </div>
    </>
  );
};

export default BidPickerList;
